module.exports = __webpack_public_path__ + "media/images/blog/placeholder-640ddc77fca8970e030f7cdea35819e1.png";